import axios from 'axios'
import Cookies from "js-cookie";
import {
  Notification
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
//import Store from '@/store'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
   /*headers: {
     'Authorization': Cookies.get('token') || ''
   },*/
  timeout: 5 * 60 * 1000
})
service.interceptors.request.use(
  config => {
    if (Cookies.get('token')) {
      config.headers['Authorization'] = 'Bearer ' + Cookies.get('token')  // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    const result = config.data
    config.data = result
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // 错误处理
    switch (res.code) {
      case 401:
        location.href = '#/login';
        break
      default:
        return res
    }
    return res
  },
  (error) => {
    NProgress.done()
    if (error.message != 'Network Error') {
      Notification({
        title: '错误',
        type: 'error',
        message: error.message != 'Request failed with status code 501' ? error.msg || error.message : '暂无可导出数据',
        position: 'bottom-right'
      })
    } else {
      Notification({
        title: '错误',
        type: 'error',
        message: '您的网络发生异常，无法连接服务器',
        position: 'bottom-right'
      })
    }

    return Promise.reject(error)
  }
)

export default service
